import { render } from "./VariantsTableRow.vue?vue&type=template&id=4b9a928d"
import script from "./VariantsTableRow.vue?vue&type=script&lang=js"
export * from "./VariantsTableRow.vue?vue&type=script&lang=js"

import "./VariantsTableRow.vue?vue&type=style&index=0&id=4b9a928d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__